import React from 'react';
import {
  VStack,
  Flex,
  Text,
  useColorModeValue,
  Box,
} from '@chakra-ui/react';
import { CaretDown, Scroll } from '@phosphor-icons/react';
import CommentItem from './CommentItem';

const ReplyList = ({
  replies,
  parentId,
  isCollapsed,
  onLike,
  onReply,
  replyTo,
  user,
  siteId,
  handleReplyClick,
  collapsedThreads,
  toggleThread,
  borderColor,
  depth = 0
}) => {
  const bgColor = useColorModeValue('white', 'gray.700');
  const textColor = useColorModeValue('ancient.stone', 'whiteAlpha.800');
  const hoverBg = useColorModeValue('ancient.parchment', 'gray.600');
  const boxShadow = useColorModeValue('0 1px 2px rgba(0,0,0,0.05)', '0 1px 2px rgba(0,0,0,0.2)');

  if (!replies || replies.length === 0) return null;

  if (isCollapsed) {
    return (
      <Flex
        ml={{ base: 4, md: 6 }}
        mt={2}
        p={2}
        alignItems="center"
        cursor="pointer"
        role="button"
        onClick={(e) => toggleThread(parentId, e)}
        tabIndex={0}
        bg={bgColor}
        borderRadius="md"
        border="1px solid"
        borderColor="ancient.stone"
        boxShadow={boxShadow}
        transition="all 0.2s"
        _hover={{
          bg: hoverBg,
          transform: 'translateY(-1px)',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}
        _active={{
          transform: 'translateY(0)',
          boxShadow: '0 1px 2px rgba(0,0,0,0.1)'
        }}
      >
        <Box mr={2} color="ancient.terracotta">
          <Scroll weight="duotone" size={16} />
        </Box>
        <CaretDown size={14} style={{ marginRight: '8px', color: 'var(--chakra-colors-ancient-stone)' }} />
        <Text 
          fontSize="sm" 
          color={textColor}
          textStyle="papyrus"
        >
          {replies.length} {replies.length === 1 ? 'reply' : 'replies'}
        </Text>
      </Flex>
    );
  }

  return (
    <VStack 
      align="stretch" 
      spacing={2} 
      ml={{ base: 2, md: 3 }}
      position="relative"
      _before={depth > 0 ? {
        content: '""',
        position: 'absolute',
        left: '-2px',
        top: 0,
        bottom: 0,
        width: '2px',
        bg: 'ancient.stone',
        opacity: 0.3
      } : undefined}
    >
      {replies.map((reply) => (
        <CommentItem
          key={reply.id}
          comment={reply}
          user={user}
          siteId={siteId}
          onLike={onLike}
          onReply={onReply}
          replyTo={replyTo}
          handleReplyClick={handleReplyClick}
          collapsedThreads={collapsedThreads}
          toggleThread={toggleThread}
          borderColor={borderColor}
          isTopLevel={false}
        />
      ))}
    </VStack>
  );
};

export default ReplyList;
